// extracted by mini-css-extract-plugin
export default {"trilha":"ProgressBar_trilha__Wt-K7","preenchimento":"ProgressBar_preenchimento__zTZMh"};